import * as React from "react";
import {Box, Typography} from "@mui/material";

export default function AgingTierCard({tier, onClick}) {
    return (
        <Box component="button" type="button" onClick={onClick}
             sx={(theme) => ({
                 gridColumn: 'span 1',
                 minWidth: 0,
                 containerType: 'inline-size',
                 textAlign: 'left',
                 font: 'inherit',
                 cursor: 'pointer',
                 border: `1px solid ${theme.palette.divider}`,
                 borderTop: `3px solid ${tier.color}`,
                 borderRadius: 0.8,
                 backgroundColor: theme.brand.chrome,
                 color: theme.palette.text.primary,
                 padding: 1,
                 boxShadow: tier.selected ? `inset 0 0 0 2px ${tier.color}` : 'none',
                 transition: 'transform 120ms ease, box-shadow 120ms ease',
                 '&:hover': {
                     transform: 'translateY(-1px)',
                     boxShadow: tier.selected
                         ? `inset 0 0 0 2px ${tier.color}, ${theme.shadows[4]}`
                         : theme.shadows[4],
                 },
                 '&:focus-visible': {outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2},
             })}>
            <Typography variant="caption" component="div" fontWeight={700} color="text.secondary"
                       sx={{minHeight: '2.4em', lineHeight: 1.2}}>
                {tier.label}
            </Typography>
            <Typography variant="subtitle1" fontWeight={700}
                       sx={{fontVariantNumeric: 'tabular-nums', marginTop: 0.5,
                           fontSize: 'clamp(0.6rem, 7cqi, 1rem)', whiteSpace: 'nowrap'}}>
                {tier.amount}
            </Typography>
            <Box sx={(theme) => ({
                height: 4, borderRadius: 0.2, backgroundColor: theme.palette.divider, marginTop: 1,
            })}>
                <Box sx={{height: '100%', width: `${tier.barPercentage}%`, backgroundColor: tier.color, borderRadius: 0.2}}/>
            </Box>
        </Box>
    );
}
